export const TRANSLATIONS_KU = {
  "One link for everything you make, share and sell — free, no paywall on the core tools.": "یەک لینک بۆ هەموو ئەوەی دروستی دەکەیت، بڵاوی دەکەیتەوە و دەیفرۆشیت - بەخۆڕایی، بەبێ هیچ پارەدانێک بۆ ئامرازە سەرەکییەکان.",
  "Footer navigation": "ڕێنیشاندەری خوارەوە",
  "Explore": "دۆزینەوە",
  "Home": "سەرەتا",
  "About": "دەربارە",
  "QR Code Generator": "دروستکەری کیو ئاڕ کۆد (QR)",
  "Contact": "پەیوەندی",
  "Get in touch": "پەیوەندیمان پێوە بکە",
  "All rights reserved.": "هەموو مافەکان پارێزراون.",
  "Crop photo": "بڕینی وێنە",
  "Drag to reposition, pinch or use the slider to zoom": "ڕایبکێشە بۆ گۆڕینی شوێنەکەی، پەنجەکانت لێک نزیک بکەرەوە یان سڵایدەرەکە بەکاربهێنە بۆ نزیککردنەوە",
  "Close": "داخستن",
  "This image could not be opened": "ئەم وێنەیە نەکرایەوە",
  "Zoom out": "دوورکردنەوە",
  "Zoom": "زووم / قەبارە",
  "Zoom in": "نزیککردنەوە",
  "Reset": "گێڕانەوەی بنەڕەت",
  "Cancel": "هەڵوەشاندنەوە",
  "Saving...": "پاشەکەوت دەکرێت...",
  "Apply": "جێبەجێکردن",
  "Change language": "گۆڕینی زمان",
  "Main navigation": "ڕێنیشاندەری سەرەکی",
  "Logout": "چوونەدەرەوە",
  "Login": "چوونەژوورەوە",
  "Open menu": "کردنەوەی مینو",
  "Close menu": "داخستنی مینو",
  "Language": "زمان",
  "QR Generator": "دروستکەری QR",
  "Download": "داگرتن",
  "About Linkakam": "دەربارەی Linkakam",
  "A link in bio tool that doesn't paywall the basics.": "ئامرازێکی لینکی بایۆ کە پارە بۆ تایبەتمەندییە سەرەتاییەکان داوا ناکات.",
  "Linkakam started from a simple frustration: the tools creators need most — a clean link page, a working contact form, real analytics — are usually the first things locked behind a subscription. We built Linkakam the other way around.": "Linkakam لە بێزارییەکی سادەوە دەستی پێکرد: ئەو ئامرازانەی دروستکەران زۆرترین پێویستیان پێیەتی — پەڕەیەکی لینکی خاوێن، فۆڕمێکی پەیوەندی کارا، شیکاریی ڕاستەقینە — زۆرجار یەکەم شتن کە بە پارە دەکرێن. ئێمە Linkakamـمان بە پێچەوانەوە دروستکرد.",
  "“We'd rather earn trust by being useful for free than earn revenue by holding features back.”": "\"پێمان باشترە متمانە بەدەست بهێنین بەوەی بەخۆڕایی سوودبەخش بین، نەک داهات بەدەست بهێنین لە ڕێگەی شاردنەوەی تایبەتمەندییەکانەوە.\"",
  "Build your page in a few minutes.": "پەڕەکەت لە چەند خولەکێکدا دروست بکە.",
  "No credit card. No trial countdown. Just your links, live.": "بەبێ کارتی بانکی. بەبێ کاتی تاقیکردنەوە. تەنها لینکەکانت، بە ڕاستەوخۆیی.",
  "Create your link": "لینکەکەت دروست بکە",
  "Free means free": "بەخۆڕایی واتە بەخۆڕایی",
  "Your link page, forms and analytics stay free as your audience grows. No feature paywall waiting for you at 1,000 followers.": "پەڕەی لینکەکەت، فۆڕمەکان و شیکارییەکان بەخۆڕایی دەمێننەوە لەگەڵ گەشەکردنی بینەرەکانت. هیچ پارەدانێک بۆ تایبەتمەندییەکان چاوەڕێت ناکات کاتێک دەگەیتە ١،٠٠٠ فۆڵۆوەر.",
  "Built for creators first": "لە پێشدا بۆ دروستکەران دروستکراوە",
  "Every tool we ship — link pages, QR codes, CVs, storefronts — starts from what people actually build with their bio link, not what upsells well.": "هەموو ئەو ئامرازانەی بڵاوی دەکەینەوە — پەڕەکانی لینک، کۆدەکانی QR، سیڤییەکان (CV)، فرۆشگاکان — لەوەوە دەست پێدەکەن کە خەڵک بەڕاستی چی بە لینکی بایۆکەیان دروست دەکەن، نەک ئەوەی چی باش دەفرۆشرێت.",
  "One link, fully yours": "یەک لینک، بەتەواوی بۆ تۆ",
  "Your profile, your links, your data. Export it, move it, or take it down whenever you want.": "پرۆفایلەکەت، لینکەکانت، زانیارییەکانت. دەتوانیت بیانبەیتە دەرەوە، بیانگوازیتەوە، یان هەرکاتێک ویستت بیانسڕیتەوە.",
  "Talk to us": "قسەمان لەگەڵ بکە",
  "Questions, feedback, or a bug to report — we read every message.": "پرسیار، فیدباک، یان کێشەیەک هەیە بیڵێیت — ئێمە هەموو نامەیەک دەخوێنینەوە.",
  "Email": "ئیمەیڵ",
  "Phone": "تەلەفۆن",
  "Name": "ناو",
  "Subject": "بابەت",
  "Message": "نامە",
  "Sending...": "دەنێردرێت...",
  "Send message": "ناردنی نامە",
  "Message sent — we'll get back to you soon.": "نامەکە نێردرا — بەمزوانە وەڵامت دەدەینەوە.",
  "Something went wrong sending your message. Please email us directly at support@linkakam.com.": "هەڵەیەک ڕوویدا لە ناردنی نامەکەت. تکایە ڕاستەوخۆ ئیمەیڵمان بۆ بنێرە بۆ support@linkakam.com.",
  "Everything you make,": "هەموو ئەوەی دروستی دەکەیت،",
  "one link away.": "تەنها بە یەک لینک.",
  "Create a single, shareable link for all your social profiles, business pages, product catalogs and menus — with built-in forms, analytics and QR codes, free.": "یەک لینکی هاوبەش بۆ هەموو پرۆفایلە کۆمەڵایەتییەکانت، پەڕە بازرگانییەکان، لیستی بەرهەمەکان و مینیوەکان دروست بکە — لەگەڵ فۆڕم، شیکاری و کیو ئاڕ کۆد (QR)، بەخۆڕایی.",
  "See how it works": "ببینە چۆن کاردەکات",
  "Search For Profile": "گەڕان بۆ پرۆفایل",
  "Search": "گەڕان",
  "A Linkakam profile page on a phone": "پەڕەی پرۆفایلی Linkakam لەسەر مۆبایل",
  "Profile visits": "سەردانەکانی پرۆفایل",
  "Scan to share": "سکان بکە بۆ بڵاوکردنەوە",
  "How it works": "چۆن کاردەکات",
  "Back to home": "گەڕانەوە بۆ سەرەتا",
  "Search results": "ئەنجامەکانی گەڕان",
  "Searching...": "دەگەڕێت...",
  "profile": "پرۆفایل",
  "profiles": "پرۆفایلەکان",
  "for": "بۆ",
  "No profiles found": "هیچ پرۆفایلێک نەدۆزرایەوە",
  "Check the spelling or try a different username.": "ڕێنووسەکە بپشکنە یان ناوێکی بەکارهێنەری جیاواز تاقی بکەرەوە.",
  "Add all your links": "هەموو لینکەکانت زیاد بکە",
  "Connect your socials, store, videos, music, podcast and events. It all comes together on one page designed to convert.": "تۆڕە کۆمەڵایەتییەکانت، فرۆشگاکەت، ڤیدیۆکان، میوزیک، پۆدکاست و بۆنەکانت ببەستەوە. هەمووی لە یەک پەڕەدا کۆدەبێتەوە کە بۆ سەرنجڕاکێشان دیزاین کراوە.",
  "Help your followers": "یارمەتی فۆڵۆوەرەکانت بدە",
  "Help your followers discover everything you're sharing all over the internet, in one simple place. They'll thank you for it.": "یارمەتی فۆڵۆوەرەکانت بدە بۆ ئەوەی هەموو ئەوەی لە ئینتەرنێتدا بڵاوی دەکەیتەوە لە یەک شوێنی سادەدا بیبینن. سوپاسگوزارت دەبن بۆ ئەوە.",
  "Share it everywhere": "لە هەموو شوێنێک بڵاوی بکەرەوە",
  "Add your unique Linkakam URL to every platform your audience is on, then use your QR code to bring offline traffic online.": "لینکی تایبەتی Linkakamـەکەت بۆ هەموو پلاتفۆرمەکان زیاد بکە، پاشان کیو ئاڕ کۆدەکەت (QR) بەکاربهێنە بۆ هێنانی سەردانکەران لە دەرەوەی هێڵ بۆ ناو ئینتەرنێت.",
  "Something went wrong. Please try again.": "هەڵەیەک ڕوویدا. تکایە دووبارە تاقی بکەرەوە.",
  "Invalid username or password": "ناوی بەکارهێنەر یان تێپەڕوشە هەڵەیە",
  "The link was sent to your email": "لینکەکە نێردرا بۆ ئیمەیڵەکەت",
  "check your email": "ئیمەیڵەکەت بپشکنە",
  "Oops...": "ئۆهـ...",
  "Email not found": "ئیمەیڵ نەدۆزرایەوە",
  "Username cannot contain spaces": "ناوی بەکارهێنەر نابێت بۆشایی تێدابێت",
  "Please enter your email first": "تکایە سەرەتا ئیمەیڵەکەت بنووسە",
  "An error occurred": "هەڵەیەک ڕوویدا",
  "Please enter the code sent to your email": "تکایە ئەو کۆدە بنووسە کە نێردراوە بۆ ئیمەیڵەکەت",
  "Passwords do not match": "تێپەڕوشەکان وەک یەک نین",
  "Please verify your email before submitting": "تکایە پێش ناردن ئیمەیڵەکەت پشتڕاست بکەرەوە",
  "All your links, in one place": "هەموو لینکەکانت لە یەک شوێن",
  "Register": "خۆتۆمارکردن",
  "Please Log In": "تکایە بڕۆ ژوورەوە",
  "Username": "ناوی بەکارهێنەر",
  "Password": "تێپەڕوشە",
  "Remember me": "بمگێڕەوە یاد",
  "Forgot your password?": "تێپەڕوشەت لەبیرچووە؟",
  "Submit": "ناردن",
  "Don't have an account?": "هەژمارت نییە؟",
  "Register Please": "تکایە خۆت تۆمار بکە",
  "User Name": "ناوی بەکارهێنەر",
  "email": "ئیمەیڵ",
  "Verified": "پشتڕاستکرایەوە",
  "Resend": "ناردنەوە",
  "Verify": "پشتڕاستکردنەوە",
  "Enter the 6-digit code": "کۆدە ٦ ژمارەییەکە بنووسە",
  "Checking...": "دەپشکنێت...",
  "Confirm": "دڵنیاکردنەوە",
  "Confirm Password": "دڵنیاکردنەوەی تێپەڕوشە",
  "Already have an account?": "پێشتر هەژمارت هەیە؟",
  "Reset password": "گۆڕینەوەی تێپەڕوشە",
  "Enter your email and you will receive a reset password link": "ئیمەیڵەکەت بنووسە و لینکی گۆڕینی تێپەڕوشەت پێ دەگات",
  "Verify your email": "ئیمەیڵەکەت پشتڕاست بکەرەوە",
  "We sent a 6-digit code to": "کۆدێکی ٦ ژمارەییمان نارد بۆ",
  "Verification code": "کۆدی پشتڕاستکردنەوە",
  "Code expires in": "کۆدەکە بەسەردەچێت لە",
  "Code expired": "کۆدەکە بەسەرچوو",
  "Resend code": "ناردنەوەی کۆد",
  "Back to login": "گەڕانەوە بۆ چوونەژوورەوە",
  "Paste a link or type text first": "سەرەتا لینکێک پەیس بکە یان دەقێک بنووسە",
  "Couldn't generate that QR code, try a shorter link": "نەتوانرا ئەو کیو ئاڕ کۆدە دروست بکرێت، لینکێکی کورتتر تاقی بکەرەوە",
  "Tool": "ئامراز",
  "Generate your QR code": "کیو ئاڕ کۆدەکەت دروست بکە",
  "Turn your Linkakam profile or any link into a QR code you can print, share and download.": "پرۆفایلی Linkakamـەکەت یان هەر لینکێک بکە بە کیو ئاڕ کۆدێک کە بتوانیت چاپی بکەیت، بڵاوی بکەیتەوە و دایبگریت.",
  "Link or text": "لینک یان دەق",
  "Use my profile link": "لینکی پرۆفایلەکەم بەکاربهێنە",
  "QR code type": "جۆری کیو ئاڕ کۆد",
  "Link / Text": "لینک / دەق",
  "Wi-Fi": "وایفای",
  "WPA/WPA2": "WPA/WPA2",
  "WEP": "WEP",
  "None": "هیچ",
  "Network name (SSID)": "ناوی تۆڕ (SSID)",
  "Security": "پاراستن",
  "Show": "پیشاندان",
  "Hide": "شاردنەوە",
  "Hidden network": "تۆڕی شاراوە",
  "Enter the network name": "ناوی تۆڕەکە بنووسە",
  "Enter the Wi-Fi password": "وشەی نهێنی وایفای بنووسە",
  "Foreground color": "ڕەنگی پێشەوە",
  "Background color": "ڕەنگی پاشبنەما",
  "Add Linkakam logo to the center": "لۆگۆی Linkakam زیاد بکە بۆ ناوەڕاست",
  "Generating...": "دروست دەکرێت...",
  "Generate": "دروستکردن",
  "Your QR code will appear here.": "کیو ئاڕ کۆدەکەت لێرە دەردەکەوێت.",
  "Download PNG": "داگرتن بە PNG",
  "Download SVG": "داگرتن بە SVG",
  "Ink": "مەرەکەب",
  "Brand blue": "شینی براند",
  "Accent pink": "پەمەیی تۆخ",
  "White": "سپی",
  "Soft grey": "خۆڵەمێشی کاڵ",
  "Cover": "بەرگ",
  "Change cover": "گۆڕینی بەرگ",
  "Remove background": "سڕینەوەی پاشبنەما",
  "Image": "وێنە",
  "Link Title": "ناونیشانی لینک",
  "Link": "لینک",
  "Avatar": "ئاڤاتار",
  "link titel": "ناونیشانی لینک",
  "iPhone preview frame": "چوارچێوەی پێشبینینی ئایفۆن",
  "Please wait for the image to finish uploading": "تکایە چاوەڕێ بکە تا بارکردنی وێنەکە تەواو دەبێت",
  "Make sure you fill in all the fields": "دڵنیابە لە پڕکردنەوەی هەموو خانەکان",
  "Could not save theme": "نەتوانرا ڕووکارەکە (theme) پاشەکەوت بکرێت",
  "Please choose an image file": "تکایە فایلێکی وێنە هەڵبژێرە",
  "Crop cover": "بڕینی بەرگ",
  "Crop image": "بڕینی وێنە",
  "Loading": "باردەکرێت",
  "Bio": "بایۆ",
  "Theme": "ڕووکار",
  "select": "هەڵبژاردن",
  "Website": "وێبسایت",
  "Call": "پەیوەندیکردن",
  "Other": "تر",
  "Add": "زیادکردن",
  "Add image": "زیادکردنی وێنە",
  "View as visitor": "بینین وەک سەردانکەر",
  "Share": "بڵاوکردنەوە",
  "Live preview · updates as you type": "پێشبینینی ڕاستەوخۆ · نوێ دەبێتەوە کاتێک دەنووسیت",
  "Preview": "پێشبینین",
  "Profile preview": "پێشبینینی پرۆفایل",
  "Share profile": "بڵاوکردنەوەی پرۆفایل",
  "Share your profile link or QR code": "لینکی پرۆفایلەکەت یان کیو ئاڕ کۆدەکەت بڵاوبکەرەوە",
  "copy": "کۆپی کردن",
  "copied": "کۆپی کرا",
  "No links yet.": "هێشتا هیچ لینکێک نییە.",
  "Powered by Linkakam": "بە پاڵپشتی Linkakam",
  "Back": "گەڕانەوە",
  "Copy profile link": "کۆپیکردنی لینکی پرۆفایل",
  "Copied": "کۆپی کرا",
  "Copy link": "کۆپیکردنی لینک",
  "Mobile": "مۆبایل",
  "Tablet": "تابلێت",
  "Desktop": "کۆمپیوتەر",
  "Please choose a JPG, PNG or WebP image": "تکایە وێنەیەکی JPG، PNG یان WebP هەڵبژێرە",
  "Image must be 5 MB or smaller": "وێنەکە دەبێت ٥ مێگابایت یان بچووکتر بێت",
  "Something went wrong": "هەڵەیەک ڕوویدا",
  "Network error, please try again": "هەڵەی هێڵ، تکایە دووبارە تاقی بکەرەوە",
  "Statistics": "ئامارەکان",
  "Page statistics": "ئامارەکانی پەیج",
  "Back to my page": "گەڕانەوە بۆ پەیجەکەم",
  "See how many people have visited your page.": "ببینە چەند کەس سەردانی پەیجەکەتیان کردووە.",
  "Total visits": "کۆی سەردانەکان",
  "Last 7 days": "٧ ڕۆژی ڕابردوو",
  "Last 30 days": "٣٠ ڕۆژی ڕابردوو",
  "This month": "ئەم مانگە",
  "No visits last month": "مانگی ڕابردوو سەردان نەبوو",
  "vs last month": "بە بەراورد بە مانگی ڕابردوو",
  "No visits yet": "هێشتا سەردان نییە",
  "Share your page link to start seeing visits here.": "لینکی پەیجەکەت هاوبەش بکە بۆ ئەوەی سەردانەکان لێرە ببینیت.",
  "Visits per month": "سەردان بەپێی مانگ",
  "Last 12 months": "١٢ مانگی ڕابردوو",
  "Best month": "باشترین مانگ",
  "Monthly average": "تێکڕای مانگانە",
  "Visits today": "سەردانەکانی ئەمڕۆ",
  "Daily visits": "سەردانی ڕۆژانە",
  "My page": "پەیجەکەم",
  "Link copied": "لینک کۆپی کرا",
  "Account menu": "لیستی هەژمار"
};
